export default [
  {
    path: '/activity-20260331-main',
    component: () => import('./Page.vue'),
    meta: { title: '愚人节', id: 26 },
  },
  {
    path: '/activity-20260331-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '愚人节-规则', id: 26 },
  },
]
